//////////////////
// Cookies management
//////////////////
App.Cookies = (function() {

  // Disable tracking if the opt-out cookie exists.
  var gaDisableStr = 'ga-disable-' + window.gaID;
  if (document.cookie.indexOf(gaDisableStr + '=true') > -1) {
    window[gaDisableStr] = true;
  }

  App.register(function() {
    App.log("Registered: App.Cookies");
  });

  // Opt-out function
  return {
    gaOptOut : function() {
      document.cookie = gaDisableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
      window[gaDisableStr] = true;
      alert("You have been successfully opted-out");
      return(window[gaDisableStr]);
    }
  }

})();
